// extracted by mini-css-extract-plugin
export default {"_":"Fallback____npWMR"};